<sliding-panel class="sliding-panel-payment-calendar" [exit]="exit">
	<div class="top-section">
		<!-- Header -->
		<div class="header">
			<div class="title-section">
				<div
					class="dot"
					[ngClass]="{
						tpp1: milestoneGroup.group === 'TPP1',
						tpp2: milestoneGroup.group === 'TPP2',
						tpp3: milestoneGroup.group === 'TPP3',
						tpp4: milestoneGroup.group === 'TPP4',
						net: milestoneGroup.group === 'NETS'
					}"
				></div>
				<div class="text">
					@if(milestoneGroup.type === 'TPP') { <span>GROUP</span> } {{ milestoneGroup.group }}
				</div>
			</div>

			<div class="cta-container">
				<div class="reset-button" id="resetButton" (click)="resetAll()" aria-hidden="true">Reset all</div>
				<div class="close-button" id="closeButton" (click)="cancel(false)" aria-hidden="true">
					<app-icon
						[name]="'close'"
						[color]="'var(--color-text-default)'"
						[size]="'45'"
						[lineWidth]="'1px'"
					></app-icon>
				</div>
			</div>
		</div>

		<app-legal-entity-timezone-disclaimer
			[milestoneDate]="_date"
			[payGroup]="payGroup"
			[textMessage]="'Your calendar events will be set in your local time zone'"
		></app-legal-entity-timezone-disclaimer>

		<!-- Form -->
		<div class="form-container">
			@if(eventForm) {
			<!-- Title netBookingDate -->
			<div class="title-form">Set booking date</div>

			<!-- Inputs netBookingDate -->
			<div class="inputs-container o-grid-2 full-width" [formGroup]="eventForm">
				<input-wrapper label="Date">
					<mat-form-field appearance="outline" (click)="picker.open()">
						<mat-datepicker-toggle matPrefix [for]="picker">
							<app-icon
								matDatepickerToggleIcon
								class="icon-payments"
								[name]="'calendar_month'"
								[color]="'var(--color-primary-1000)'"
							></app-icon>
						</mat-datepicker-toggle>
						<input
							id="netBookingDate"
							formControlName="netBookingDate"
							matInput
							[matDatepicker]="picker"
							readonly
							[attr.data-test]="'net-booking-create-selected-date'"
						/>
						@if(!eventForm.get('netBookingDate')?.value) { <mat-label>Select a booking date</mat-label> }
						<mat-datepicker
							#picker
							(opened)="openDatePicker('booking-date')"
							(viewChanged)="datePickerViewChange($event, 'booking-date')"
						></mat-datepicker>
					</mat-form-field>
				</input-wrapper>
				<input-wrapper label="Time (UTC)">
					<div class="div-time-container flex flex-row">
						<app-icon class="icon-time" [name]="'clock-1'" [color]="'var(--color-primary-1000)'"></app-icon>
						<input
							id="netBookingTime"
							type="time"
							formControlName="netBookingTime"
							placeholder="Time"
							[attr.data-test]="'net-booking-create-selected-time'"
						/>
					</div>
				</input-wrapper>
			</div>

			<!-- Title -->
			<div class="title-form">{{ setDateTitle }}</div>

			<!-- Inputs -->
			<div class="inputs-container o-grid-2 full-width" [formGroup]="eventForm">
				<!-- Pay date offset -->
				<input-wrapper label="Pay date">
					<div id="displayDateWrapper" fxLayout="row">
						<app-icon
							class="icon-payments-creation"
							[name]="'calendar_month'"
							[color]="'var(--color-primary-1000)'"
						></app-icon>
						<input
							id="displayDate"
							type="text"
							formControlName="displayDate"
							[attr.data-test]="'net-payment-create-set-date'"
						/>
					</div>
				</input-wrapper>

				<!-- Event time -->
				<input-wrapper label="Event time (UTC)">
					<div class="div-time-container" fxLayout="row">
						<app-icon class="icon-time" [name]="'clock-1'" [color]="'var(--color-primary-1000)'"></app-icon>

						<input
							id="time"
							type="time"
							formControlName="time"
							placeholder="Event time"
							[attr.data-test]="'net-payment-create-selected-time'"
						/>
					</div>
					@if(eventForm.controls.time.errors?.required){
					<div input-errors>Event time is required</div>
					}
				</input-wrapper>
			</div>
			}
		</div>
	</div>

	<!-- CTA -->
	<div class="cta-container">
		<button
			id="cancelButton"
			class="cancel-button"
			action-buttons
			mat-stroked-button
			(click)="cancel(false)"
			[attr.data-test]="'calendar-milestone-create-cancel-button'"
		>
			Cancel
		</button>
		<button
			id="saveButton"
			class="save-button"
			action-buttons
			mat-flat-button
			color="dark"
			(click)="save()"
			[disabled]="eventForm ? eventForm.invalid : true"
			[attr.data-test]="'calendar-milestone-create-save-button'"
		>
			Save
		</button>
	</div>
</sliding-panel>
